/* eslint-disable @typescript-eslint/no-explicit-any */
import { Capacitor } from "@capacitor/core";
import { clientConfigFn, defaultClientConfig, } from "clientConfig";
export function SetBaseUris(capitalApiBaseUri, deviceAssetsBaseUri) {
    if (window.__INTERFI__ == null) {
        window.__INTERFI__ = {
            ...defaultClientConfig,
        };
    }
    const windowConfig = window && window.__INTERFI__;
    if (capitalApiBaseUri) {
        windowConfig.capitalApiBaseUri = capitalApiBaseUri;
    }
    if (deviceAssetsBaseUri) {
        windowConfig.deviceAssetsBaseUri = deviceAssetsBaseUri;
    }
}
export function GetAssetUri(path) {
    const deviceAssetsBaseUri = clientConfigFn().deviceAssetsBaseUri;
    const Platform = Capacitor.getPlatform();
    if (Platform !== "web" && deviceAssetsBaseUri) {
        return `${deviceAssetsBaseUri}${path}`;
    }
    return path;
}
